import {Component, Inject, Input, Output, Pipe, PipeTransform, ViewChild, HostListener, EventEmitter, OnDestroy, ViewChildren, QueryList} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

import {ApiService} from '../shared/api.service';
import {Site} from '../shared/site.model';
import { finalize } from 'rxjs/operators';
import {ImagesService} from '../shared/images.service';
import {SlideshowService} from '../slideshow/slideshow.service';

@Pipe({name: 'siteSearch'})
export class SiteSearchPipe implements PipeTransform {
    transform(list, text): string {
        if( !list || !text ) {
            return list;
        }
        return list.filter(item => {
            const blog_id = item.blog_id + '';
            return item.name.indexOf(text) !== -1 || 
                item.domain.indexOf(text) !== -1 || 
                blog_id.indexOf(text) !== -1 || 
                item.abbreviation.indexOf(text) !== -1 ? true : false;
        });
    }
}
@Pipe({
    name: 'hasSite',
    pure: false
})
export class HasSitePipe implements PipeTransform {
    transform(list, sites): string {
        if( !list || !sites ) {
            return list;
        }
        const blog_ids = sites.map(site => site.blog_id);
        return list.filter(item => {
            return blog_ids.indexOf(item.blog_id) === -1;
        });
    }
}

@Component({
    selector: 'properties-component',
    templateUrl: 'properties.component.html'
})
export class PropertiesComponent implements OnDestroy {
    limited = false;
    options = [];
    panelOpen = false;
    siteSearchText = '';
    hideKeys = [
        'hideOnFront', 
        'hideOnCategory',
        'hideOnTag',
        'hideOnDate',
        'hideOnAuthor',
        'hideOnSearch',
        'hideOnFeed',
        'hideOnGoogle'
    ];
    primaryCategories = [];

    private _canEdit = false;
    private _editMeta = true;
    private _editSlug = true;
    private _properties = [];
    private _showMeta = true;
    private _showFacebook = false;

    @Input('canEdit')
    set canEdit(canEdit) {
        this._canEdit = canEdit;
    }
    get canEdit() {
        return this._canEdit;
    }
    @Input('editMeta') 
    set editMeta(editMeta) {
        this._editMeta = editMeta;
    }
    get editMeta() {
        return this._editMeta;
    }
    @Input('editSlug') 
    set editSlug(editSlug) {
        this._editSlug = editSlug;
    }
    get editSlug() {
        return this._editSlug;
    }
    @Input('properties') 
    set properties(properties) {
        this._properties = properties;
    }
    get properties() {
        return this._properties;
    }
    @Input('showMeta') 
    set showMeta(showMeta) {
        this._showMeta = showMeta;
    }
    get showMeta() {
        return this._showMeta;
    }
    @Input('showFacebook') 
    set showFacebook(showFacebook) {
        this._showFacebook = showFacebook;
    }
    get showFacebook() {
        return this._showFacebook;
    }

    @Output() propertiesChange = new EventEmitter();

    @ViewChildren('siteCategory') siteCategoryEls;

    @ViewChild('dropdown') dropdown;
    @HostListener('document:click', ['$event'])
    clickout(event) {
        if( this.dropdown && !this.dropdown.nativeElement.contains(event.target)) {
            this.panelOpen = false;
        }
    }

    constructor(private api: ApiService, private dialog: MatDialog) {
        this.options = this.api.getProp('sites');
        this.options = this.options.map(item => new Site(item));
    }
    ngAfterViewInit() {
        const user = this.api.getProp('user');
        if( user.limited.length > 0 ) {
            this.limited = true;
            this.options = this.options.filter(item => user.limited.indexOf(item.blog_id) !== -1);
            if( this.options.length == 1 ) {
                const option = this.options.shift();
                const properties = this.properties;
                for(var i = 0; i < properties.length; i++) {
                    if( properties[i].blog_id == option.blog_id ) {
                        return;
                    }
                }
                this.addSite(option);
            }
        }
    }
    addSite(option) {
        const site = JSON.parse(JSON.stringify(option));
        if( this.properties.length == 0 ) {
            site.primary = true;
        }
        if( !site.primary ) {
            this.addPrimaryCats(site);
            this.hidePost(site, true);
        }
        this.properties.push(site);
        this.propertiesChange.emit(this.properties);
    }
    addPrimaryCats(site) {
        const primary = this.properties.filter(item => item.primary).shift();
        if( primary ) {
            site.primaryCats = JSON.parse(JSON.stringify(primary.categories));
        }
    }
    updateSiteCategories(e) {
        if( e.site.primary && e.added && this.siteCategoryEls ) {
            const slugs = e.site.categories.map(item => item.slug);
            this.siteCategoryEls.toArray().forEach(el => {
                if( !el.site.primary ) {
                    const options = el.options;
                    for(var i = 0; i < options.length; i++) {
                        const option = options[i];
                        if( slugs.indexOf(option.slug) !== -1 ) {
                            option.checked = true;
                            el.changeOption(option);
                        }
                    }
                }
            });
        }
        if( e.site.primary ) {
            this.primaryCategories = e.site.categories;
        }
    }
    hidePost(site, hide) {
        const hideKeys = this.hideKeys;
        for(var i = 0; i < hideKeys.length; i++) {
            const key = hideKeys[i];
            site.meta[key] = hide;
        }
    }
    isChecked(site) {
        const hideKeys = this.hideKeys;
        for(var i = 0; i < hideKeys.length; i++) {
            const hide = site.meta[hideKeys[i]];
            if( hide == false ) {
                return false;
            }
        }
        return true;
    }
    isIndeterminate(site) {
        const hideKeys = this.hideKeys;
        let hasTrueValue = false;
        let hasFalseValue = false;
        for(var i = 0; i < hideKeys.length; i++) {
            const hide = site.meta[hideKeys[i]];
            if( hide == true ) {
                hasTrueValue = true;
            } else {
                hasFalseValue = true;
            }
        }
        return hasTrueValue && hasFalseValue;
    }
    openEditMeta(site) {
        if( !this.showMeta ) {
            return;
        }
        const dialog = this.dialog.open(SiteSettingsDialog, {
            data: {
                site: site,
                isChecked: this.isChecked(site),
                canEdit: this.canEdit && this.editMeta,
                hideKeys: this.hideKeys,
                showFacebookSettings: this.showFacebook
            }
        });
    }
    openEditSlug(site) {
        const dialog = this.dialog.open(SlugDialog, {
            data: site
        });
    }
    openSiteSelect(search) {
        search.focus();
        this.togglePanel(true);
    }
    removeSite(index) {
        this.properties.splice(index, 1);
        this.updatePrimary();
        this.propertiesChange.emit(this.properties);
    }
    togglePanel(open) {
        if( open ) {
            this.panelOpen = true;
            return;
        }
        this.panelOpen = !this.panelOpen;
    }
    updatePrimary() {
        const sites = this.properties;
        if( sites.length == 0 ) {
            return;
        }
        for(var i = 0; i < sites.length; i++) {
            if( sites[i].primary ) {
                return;
            }
        }
        sites[0].primary = true;
        this.hidePost(sites[0], false);
    }
    updateTerms(site, data) {
        site.taxonomies.category = data;
        if( site.primary ) {
            return;
        }
        const primary = this.properties.filter(item => item.primary).shift();
        if( !primary ) {
            return;
        }
        for(var tax in primary.taxonomies) {
            if( tax != 'category' && !site.taxonomies.hasOwnProperty(tax) ) {
                site.taxonomies[tax] = {
                    options: JSON.parse(JSON.stringify(primary.taxonomies[tax].options)),
                    terms: []
                };
            }
            const terms = primary.taxonomies[tax].terms.map(item => item.slug);
            let options = site.taxonomies[tax].options;
            for(var i = 0; i < options.length; i++) {
                let option = options[i];
                if( terms.indexOf(option.slug) !== -1 ) {
                    option.checked = true;
                    site.taxonomies[tax].terms.push(option);
                }
            }
        }
    }
    allSitesHaveCategory() {
        const sites = this.properties;
        for(var i = 0; i < sites.length; i++) {
            if( sites[i].categories.length === 0 ) {
                return false;
            }
        }
        return true;
    }
    ngOnDestroy() {
        this.panelOpen = false;
        this.siteSearchText = '';
    }
}
@Component({
    selector: 'site-settings-dialog',
    template: `
        <button [mat-dialog-close]="false" class="close faded"><mat-icon>close</mat-icon></button>
        <div mat-dialog-title>
            Settings 
            <a 
                id="title-icon"
                href="{{data.site?.permalink}}" 
                target="_blank" 
                class="site-{{data.site.abbreviation}}"
                [ngClass]="{primary: data.site.primary}">
                    {{data.site.abbreviation}}
            </a>
        </div>
        
        <mat-dialog-content class="groups">
            <div class="group">
                <mat-slide-toggle 
                    id="publish-toggle" 
                    [disabled]="!canEdit" 
                    [(ngModel)]="publish" 
                    (change)="setStatus($event)" 
                    [ngClass]="{warn: !publish}">
                    Publish
                </mat-slide-toggle>
            </div>
            <div class="group">
                <label>Next Post Link</label>
                <div class="input-wrap">
                    <textarea 
                        id="next-post-link" 
                        placeholder="URL"
                        [readonly]="!canEdit" 
                        [(ngModel)]="data.site.nextPostLink" 
                        (input)="updateNextPostLink()" 
                        (keydown.enter)="$event.preventDefault()">
                    </textarea>
                </div>
            </div>
            <div class="group">
                <mat-slide-toggle 
                    *ngIf="data.showFacebookSettings"
                    id="fb-toggle" 
                    [disabled]="!canEdit"
                    (change)="toggleFb($event)"
                    [(ngModel)]="showFb"
                    [ngClass]="{active: showFb}">
                    Custom Facebook Meta
                </mat-slide-toggle>
            </div>
            <div *ngIf="showFb && data.showFacebookSettings" id="fb-settings" class="group">
                <div class="image">
                    <ng-container *ngIf="data.site.meta.facebookImage; else placeholder">
                        <img [src]="data.site.meta.facebookImage" (click)="openImages()">
                    </ng-container>
                    <ng-template #placeholder>
                        <div class="placeholder" (click)="openImages()"><div><mat-icon>insert_photo</mat-icon></div></div>
                    </ng-template>
                </div>
                <div class="input-wrap">
                    <label>Facebook Meta Title</label>
                    <textarea 
                        placeholder="Facebook Meta Title"
                        [readonly]="!canEdit" 
                        [(ngModel)]="data.site.meta.facebookTitle"
                        (keydown.enter)="$event.preventDefault()">
                    </textarea>
                </div>
                <div class="input-wrap">
                    <label>Facebook Meta Description</label>
                    <textarea 
                        placeholder="Facebook Meta Description"
                        [readonly]="!canEdit" 
                        [(ngModel)]="data.site.meta.facebookDescription"
                        (keydown.enter)="$event.preventDefault()">
                    </textarea>
                </div>
            </div>
            <div class="group">
                <mat-checkbox [disabled]="!canEdit" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnFront"> Hide on front page </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEdit" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnCategory"> Hide on category pages </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEdit" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnTag"> Hide on tag pages </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEdit" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnDate"> Hide on date archives </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEdit" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnAuthor"> Hide on author pages </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEdit" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnSearch"> Hide in search results </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEdit" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnFeed"> Hide in feeds </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEdit" (change)="update($event)" [(ngModel)]="data.site.meta.hideOnGoogle"> Hide from Google </mat-checkbox><br/>
                <mat-checkbox [disabled]="!canEdit" (change)="selectAll($event)" [(ngModel)]="hideOnAll"> Hide on all </mat-checkbox><br/>   
            </div>         
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="true">Done</button>
        </mat-dialog-actions>`,
})
export class SiteSettingsDialog {
    hideOnAll;
    checking = false;
    saving = false;
    canEdit = false;
    publish = true;
    showFb = false;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog) {
        this.hideOnAll = data.isChecked;
        this.canEdit = data.canEdit;
        if( data.site.newStatus == 'draft' || !data.site.newStatus && data.site.status == 'draft' ) {
            this.publish = false;
        }
        if( data.site.meta.facebookImage || data.site.meta.facebookTitle || data.site.meta.facebookDescription ) {
            this.showFb = true;
        }
    }
    selectAll(e) {
        const hide = e.checked;
        const site = this.data.site;
        const hideKeys = this.data.hideKeys;
        for(var i = 0; i < hideKeys.length; i++) {
            site.meta[hideKeys[i]] = hide;
        }
    }
    update(event) {
        if( !event.checked ) {
            this.hideOnAll = false;
        }
    }
    setStatus(e) {
        this.data.site.newStatus = e.checked ? 'publish' : 'draft';
    }
    cleanLink() {
        return this.data.site.nextPostLink.trim().replace(/[^a-zA-Z0-9-\/:\.\?=&]/gi, '');
    }
    updateNextPostLink() {
        this.data.site.nextPostLink = this.cleanLink();
    }
    removeFbImage() {
        this.data.site.meta.facebookImage = '';
        this.data.site.meta.facebookTitle = '';
        this.data.site.meta.facebookDescription = '';
    }
    toggleFb(e) {
        if( e.checked ) {
            this.showFb = true;
        } else {
            this.showFb = false;
            this.removeFbImage();
        }
    }
    openImages() {
        if( !this.data.canEdit ) {
            return;
        }
        const dialog = this.dialog.open(ImagesDialog, {
            data: this.data.images
        });
        dialog.afterClosed().subscribe(url => {
            if( url ) {
               this.data.site.meta.facebookImage = url;
            }
        });
    }
}
@Component({
    selector: 'slug-dialog',
    template: `
        <button [mat-dialog-close]="false" class="close faded"><mat-icon>close</mat-icon></button>
        <div mat-dialog-title>
            Edit Slug <a id="title-icon"
                        href="{{data?.permalink}}" 
                        target="_blank" 
                        class="site-{{data.abbreviation}}"
                        [ngClass]="{primary: data.primary}">
                            {{data.abbreviation}}
                    </a>
        </div>
        
        <mat-dialog-content id="slug">
            <slug-component 
                [(slug)]="desiredSlug"
                [blog_id]="data.blog_id"
                [post_id]="data.post_id"
                (propChange)="updateProp($event)">
            </slug-component>
        </mat-dialog-content>
        <mat-dialog-actions>
            <img class="loader" *ngIf="loading" src="/wp-content/themes/swarm/app/assets/images/loading.gif">
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" [disabled]="checked && !available" (click)="updateSlug()">Update</button>
        </mat-dialog-actions>`,
})
export class SlugDialog {
    available = false;
    checked = false;
    loading = false;
    desiredSlug = '';
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private api: ApiService, private dialogRef: MatDialogRef<SlugDialog>) {
        this.desiredSlug = data.slug;
    }
    updateProp(event) {
        this.loading = event.loading;
        this.checked = event.checked;
        this.available = event.available;
    }
    updateSlug() {
        this.api.doAction('post', 'sites', {
            action: 'update_slug',
            blog_id: this.data.blog_id,
            slug: this.desiredSlug,
            post_id: this.data.post_id
        }).pipe(
            finalize(() => {
                this.loading = false;
            })
        ).subscribe(
            data => {
                this.data.permalink = data.permalink;
                this.data.slug = data.slug;
                this.data.oldSlug = data.oldSlug;
                this.data.desiredSlug = '';
                this.dialogRef.close(data);
            }
        );
    }
}
@Component({
    selector: 'images-dialog',
    template: `
        <button [mat-dialog-close]="false" class="close faded"><mat-icon>close</mat-icon></button>
        <div mat-dialog-title>
            Select Image
        </div>
        
        <mat-dialog-content id="image-select">
            <div
                dndDropzone 
                (dndDrop)="drop($event)"
                [dndAllowExternal]="true">
                <div class="placeholder">
                    <mat-icon>insert_photo</mat-icon>
                </div>
                <div class="image"
                    *ngFor="let image of imagesService.images" 
                    (click)="selectImage(image)"
                    [ngStyle]="{
                        'background-image' : 'url(' + image.sizes?.ad?.urlWithParams + ')'
                    }">
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <img *ngIf="imagesService.uploadInProgress" src="/wp-content/themes/swarm/app/assets/images/loading.gif" class="loader"/>
            <button class="button" [mat-dialog-close]="false">Close</button>
        </mat-dialog-actions>`,
})
export class ImagesDialog {
    constructor(private dialogRef: MatDialogRef<ImagesDialog>, private imagesService: ImagesService, private slideshow: SlideshowService) {}
    selectImage(image) {
        const url = image.sizes.ad.urlWithParams;
        this.dialogRef.close(url);
    }
    drop(e) {
        const files = e.event.dataTransfer.files;
        let count = files.length;
        const imageUploadSubscription = this.imagesService.imageUploaded.subscribe(img => {
            count -= 1;
            this.selectImage(img);
            if( count == 0 ) {
                imageUploadSubscription.unsubscribe();
            }
        });
        this.imagesService.handleDropFiles(files, this.slideshow.assignment, true);
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/properties.component.ts